export default __webpack_public_path__ + "static/media/ic_archive.2ff192f0.svg";